import React from "react";
import Header from "./Header";

export default function Background(props) {
  return <Header />;
}
